import React from "react";
import cross from "../../assets/img/ico/cross.svg";
import download from "../../assets/img/ico/download.svg";

const CandidateDocumentForm = ({ setInputs, setStep, inputs }) => {

    console.log(inputs);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // setStep(4);
    }

    const backButton = (event) => {
        event.preventDefault();
        setStep(2);
    }

    return (
        <form id="interim-document" onSubmit={handleSubmit}>
            <h3>Documents complémentaires</h3>
            <p>Ajoutez les informations de votre agence d'intérim.</p>
            <div>
                <img src={cross} alt="Cross" />
                <div>
                    <h5>Extrait Kbis</h5>
                    <p>Ajoutez un extrait valide pour confirmer votre status d'agence.</p>
                </div>
                <img src={download} alt="Upload" />
            </div><div>
            <img src={cross} alt="Cross" />
                <div>
                    <h5>RIB Professionel</h5>
                    <p>Permet de simplifier les transactions financières pour la gestion des intérimaires.</p>
                </div>
                <img src={download} alt="Upload" />
        </div><div>
            <img src={cross} alt="Cross" />
                <div>
                    <h5>Autres certificats ou documents</h5>
                    <p>Ajoutez des documents supplémentaires pour renforcer votre crédibilité auprès
                        des intérimaires.</p>
                </div>
                <img src={download} alt="Upload" />
        </div>
            <div>
                <input type={"checkbox"} id="company" name="account-type" value="company"
                />
                <label htmlFor="company">Je confirme que les informations fournies sont exactes
                    et que je suis habilité à créer ce compte pour l'agence.</label>
            </div>
            <div>
                <input type={"checkbox"} id="candidate" name="account-type" value="candidate"
                />
                <label htmlFor="candidate">J'accepte les conditions générales d'utilisation et
                    la politique de confidentialité.</label>
            </div>
            <div>
                <button className="btn empty" onClick={backButton}>← Retour</button>
                <button type="submit" className="btn fill white">Terminer</button>
            </div>
        </form>

    )
}

export default CandidateDocumentForm;